import React from "react";
import ReactDOM from "react-dom";
import App from "./routes/App";
import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import mdTheme from "./theme";
import "@fontsource-variable/inter";
import Login from "routes/Login";
import LoginProvider from "providers/Login";
import NotificationProvider from "providers/Notification";
import Register from "routes/Login/register";

const router = createBrowserRouter(createRoutesFromElements(
    <Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/*" element={<App />} />
    </Route>
));

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={mdTheme}>
            {/* NS-753 */}
            {/* the login provider shows a notification when the role blocks a request */}
            <NotificationProvider>
                <LoginProvider>
                    <CssBaseline />
                    <RouterProvider router={router} />
                </LoginProvider>
            </NotificationProvider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById("root")
);
